import React from 'react';
import {
  CotacaoStatus,
  ConviteStatus,
  COTACAO_STATUS_LABEL,
  CONVITE_STATUS_LABEL,
} from '../../../interfaces/PortalCotacoes';
import './PortalBadges.css';

const COTACAO_CLASSE: Record<CotacaoStatus, string> = {
  RASCUNHO: 'pc-badge--cinza',
  ENVIADA: 'pc-badge--azul',
  EM_RESPOSTA: 'pc-badge--azul',
  EM_DECISAO: 'pc-badge--ambar',
  AGUARDANDO_APROVACAO: 'pc-badge--laranja',
  GERANDO_PEDIDOS: 'pc-badge--roxo',
  CONCLUIDA: 'pc-badge--verde',
  CANCELADA: 'pc-badge--vermelho',
};

const CONVITE_CLASSE: Record<ConviteStatus, string> = {
  CRIADO: 'pc-badge--cinza',
  ENVIADO: 'pc-badge--azul',
  VISUALIZADO: 'pc-badge--ambar',
  RESPONDIDO: 'pc-badge--verde',
  DECLINADO: 'pc-badge--vermelho',
  REVOGADO: 'pc-badge--cinza',
  BLOQUEADO_REVISAO: 'pc-badge--vermelho',
};

export const CotacaoBadge: React.FC<{ status: CotacaoStatus }> = ({ status }) => (
  <span className={`pc-badge ${COTACAO_CLASSE[status]}`}>
    <span className="pc-badge-dot" />
    {COTACAO_STATUS_LABEL[status]}
  </span>
);

/**
 * Prazo de resposta já passou e a cotação ainda recebe respostas (portal-cotacoes/at-16). Desde
 * a reunião de Compras de 28/10/2026 o prazo só AVISA: nada fecha sozinho, e quem decide encerrar
 * é o comprador. O selo existe para isso não passar despercebido.
 */
export function prazoVencido(status: CotacaoStatus, prazoRespostaAte: string | null | undefined, agora = Date.now()): boolean {
  if (!prazoRespostaAte) return false;
  if (status !== 'ENVIADA' && status !== 'EM_RESPOSTA') return false;
  return new Date(prazoRespostaAte).getTime() < agora;
}

export const PrazoVencidoBadge: React.FC = () => (
  <span className="pc-badge pc-badge--sm pc-badge--vermelho" title="O prazo passou e a cotação continua recebendo respostas até você encerrá-la.">
    Prazo vencido
  </span>
);

export const ConviteBadge: React.FC<{ status: ConviteStatus }> = ({ status }) => (
  <span className={`pc-badge pc-badge--sm ${CONVITE_CLASSE[status]}`}>{CONVITE_STATUS_LABEL[status]}</span>
);
